const css = `@keyframes Zd2o1G__shimmer{0%{background-position:200% 0}to{background-position:-200% 0}}.Zd2o1G__shimmerContainer{width:100%;flex-direction:column;gap:12px;display:flex}.Zd2o1G__shimmerLine{height:16px;width:100%;background:linear-gradient(90deg,#bebebe33 25%,#8181813d 37%,#bebebe33 63%) 0 0/400% 100%;border-radius:4px;animation:4s ease-in-out infinite Zd2o1G__shimmer}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"shimmer":"Zd2o1G__shimmer","shimmerContainer":"Zd2o1G__shimmerContainer","shimmerLine":"Zd2o1G__shimmerLine"};
